import React from 'react';
import type {AIMessageGeneratorPromptAreaProps, ChatAskPrompt} from '../../../aiMessageGenerator/utils/types';
import {toAskAnswer} from '../../utils/askOptionAnswer';
import AiAgentAsk from '../aiAgentAsk/AiAgentAsk';
import AiAgentInput from '../aiAgentInput/AiAgentInput';

interface AiAgentPromptAreaProps extends AIMessageGeneratorPromptAreaProps {
    pendingAsk: ChatAskPrompt | null;
    onClearAsk: () => void;
}

function AiAgentPromptArea({
    pendingAsk,
    onClearAsk,
    ...inputProps
}: AiAgentPromptAreaProps) {
    const {draftLoading, onSubmitPrompt} = inputProps;

    const handleSelect = (value: string, label?: string) => {
        onSubmitPrompt({
            text: toAskAnswer(value, pendingAsk),
            displayText: label || value,
        });
    };

    if(pendingAsk) {
        return (
            <AiAgentAsk
                key={pendingAsk.id ?? pendingAsk.question}
                question={pendingAsk.question}
                options={pendingAsk.options}
                draftLoading={draftLoading}
                onSelect={handleSelect}
                onDismiss={onClearAsk}
            />
        );
    }

    return <AiAgentInput {...inputProps} />;
}

export default AiAgentPromptArea;
